<div class="row" *ngIf="!isAutopayPage" [ngClass]="{'no-margin-horizontal':isAcmic}">
  <div class="col pl-xl-0 pr-xl-0" [ngClass]="{'no-padding-horizontal-mobile':isAcmic, 'paperless-padding-ma':!isAcmic }">
    <!-- <h2 [class]="isAcmic ? '' : 'title headingPprLs'" [ngClass]="{ 'no-border': !isAcmic }" *ngIf="!checkEnrollment">
         <ng-container *ngIf="isAcmic; else MAstate">
             {{ 'PAPERLESS' | translate }} {{ paperlessPage | titlecase }}
          </ng-container> 
          <ng-container *ngIf="!isAcmic">
            <div class="row text-center margin-bottom mb24">
              <div class="col"> 
                <div class="header-icon margin-bottom mb8">
                  <figure>
                    <img src="./assets/img/images/icon-paperless.svg" alt="Otp icon" />
                  </figure>
                </div>
              <h1 class="title-copy no-margin mapfre-blue-secondary"> {{ 'PAPERLESS_PROGRAM' | translate }} {{ paperlessPage | titlecase }}</h1>
              </div>
            </div> 
          </ng-container>
    </h2>  -->
    <router-outlet (activate)="checkPaperlessPage()"></router-outlet>
  </div>
</div>
<div *ngIf="isAutopayPage">
  <router-outlet (activate)="checkPaperlessPage()"></router-outlet>
</div>
